<template>
    <div class="customized">
        <div class="top">
            <img src="../image/logo.png" alt="" class="loGo">
            <el-row class="tac">
                <el-col :span="12">
                    <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                        active-text-color="#ffd04b" :unique-opened="true">
                        <el-submenu index="1">
                            <template slot="title">
                                <img src="../image/menu.png" alt="" class="logo-1">
                            </template>
                            <el-menu-item-group>
                                <template v-for="(menu, index) in navList">
                                    <el-menu-item :index="`1-${index + 1}`" v-if="menu.children.length == 0"
                                        :key="menu.index">
                                        <router-link :to="menu.route" class="linkclass">
                                            {{ menu.name }}
                                        </router-link>
                                    </el-menu-item>
                                    <el-submenu :index="`1-${index + 1}`" v-if="menu.children.length !== 0"
                                        :key="menu.index">
                                        <template slot="title">{{ menu.name }}</template>
                                        <el-menu-item v-for="(subMenu, subIndex) in menu.children"
                                            :index="`1-${index + 1}-${subIndex + 1}`" :key="subMenu.index">
                                            <router-link :to="subMenu.route" class="linkclass">{{ subMenu.name
                                            }}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-menu-item-group>

                        </el-submenu>
                    </el-menu>
                </el-col>
            </el-row>
            <!-- <div class="introduce">
                <p class="p1">智如客科技-定制开发</p>
                <p class="p1none" style="display: none;">定制开发</p>
                <p class="p2">Zhiruke Custom development -</p>
                <p class="p2none" style="display: none;">Custom development</p>
            </div> -->
            <div class="links">
                <span class="links-1">定制开发</span>
                <span class="links-2"><router-link to="flowPath" class="links-2-1">开发流程</router-link></span>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs-1">
            <el-tab-pane label="定制商城" name="first">
                <div class="first-1">
                    <div class="first-text">
                        <span data-aos="fade-left">在成熟的电商系统基础上，为您提供电商开发定制服务</span>
                        <p data-aos="fade-left">平台电商网上商城系统、移动分销、小程序商城系统、企业网店系统、新零售电商平台开发、区块链...您的电商开发需求，随商帮您实现</p>
                    </div>
                    <div class="first-image">
                        <div class="first-image-1" data-aos="fade-left" data-aos-delay="600">
                            <span>平台型商城系统</span>
                            <p>B2B2C多用户商城系统</p>
                            <p>跨境电商平台系统</p>
                            <p>o2o多门店商城系统</p>
                            <p>B2B批发商城系统</p>
                            <p>c2f定制商城系统平台</p>
                            <p>供应链电商系统</p>
                        </div>
                        <div class="first-image-2" data-aos="fade-left" data-aos-delay="800">
                            <span>零售型商城系统</span>
                            <p>B2C自营商城系统</p>
                            <p>微分销系统</p>
                            <p>小程序商城系统</p>
                            <p>APP商城系统</p>
                            <p>全渠道新零售系统</p>
                            <p>收银系统</p>
                            <p>ERP系统</p>
                        </div>
                        <div class="first-image-3" data-aos="fade-left" data-aos-delay="1000">
                            <span>手机商城系统</span>
                            <p>HTML5移动端</p>
                            <p>iOS App</p>
                            <p>Android App</p>
                            <p>微信小程序商城</p>
                            <p>商家端App</p>
                        </div>
                        <div class="first-image-4" data-aos="fade-left" data-aos-delay="1200">
                            <span>电商定制开发</span>
                            <p>定制开发电商平台</p>
                            <p>一对一全程服务</p>
                        </div>
                    </div>
                    <div class="first-text-2">
                        <div class="f-text1" data-aos="fade-left">我们的核心优势</div>
                        <div class="f-text2" data-aos="fade-left">
                            <div class="f-text2-1">
                                <img src="../image/f-img1.png" alt="">
                                <span>基于成熟商场系统</span>
                                <p>基于稳定的SuteShop网上商城系统电商标准功能基础上定制开发，极大降低开发成本；LAMP开源架构，先进OOP开发理念，全新MVC框架设计，提高开发效率</p>
                            </div>
                            <div class="f-text2-2">
                                <img src="../image/f-img2.png" alt="">
                                <span>方案优势</span>
                                <p>我们在电商领域耕耘10余年，针对客户个性化需求打造专属解决方案，应对行业、角色不同的业务功能需求，个性化定制专属电商系统</p>
                            </div>
                            <div class="f-text2-3">
                                <img src="../image/f-img3.png" alt="">
                                <span>技术优势</span>
                                <p>我们已经建立了一个100多人的团队，系统可靠性高；负载均衡、动静分离、高效缓存、集群部署、心跳检查、读写分离、最优化的数据库设计助力高并发高可用</p>
                            </div>
                            <div class="f-text2-4">
                                <img src="../image/f-img4.png" alt="">
                                <span>服务优势</span>
                                <p>从评估需求到开发计划，我们都是仔细评估后才承诺；为了保证客户的利益，我们在合同中约定未按时交付的罚金；用契约和行动来证明我们的实力和信用</p>
                            </div>
                        </div>
                    </div>
                    <div class="first-text-3">
                        <div class="f-text-3-1">
                            <span data-aos="zoom-in-right">随商电商网站建设 全方位服务保障</span>
                            <p data-aos="zoom-in-right">依托高质量的电商系统，我们提供更好的服务！富有经验的电商运营规划人员，为客户提供符合行业实际的运营策略和建设方案辅助客户电商运营决策
                            </p>
                        </div>
                        <div class="f-text-3-2" data-aos="zoom-in-right">
                            <div class="f-text3-2-1">
                                <img src="../image/f-img5.png" alt="">
                                <span>诚信品牌</span>
                                <p>强大的技术团队，可根据您的项目需求，为您专属定制开发，为您打造一站式电商网站建设服务平台</p>
                            </div>
                            <div class="f-text3-3-1">
                                <img src="../image/f-img6.png" alt="">
                                <span>及时响应</span>
                                <p>电话、工单，随商的售后服务部门随时为你提供迅速响应服务,及时应对客户提出的运营、技术难题！</p>
                            </div>
                            <div class="f-text3-4-1">
                                <img src="../image/f-img7.png" alt="">
                                <span>诚信品牌</span>
                                <p>产品手册、操作教程、使用培训、安装帮助一应俱全，提供二次开发说明培训</p>
                            </div>
                            <div class="f-text3-5-1">
                                <img src="../image/f-img8.png" alt="">
                                <span>技术支持</span>
                                <p>安排专属售后协助您从域名备案、网站安装、后台操作指引、服务器环境配置等等，全程为您提供技术指导</p>
                            </div>
                        </div>
                    </div>
                    <div class="case" data-aos="zoom-in-up">
                        <div class="case-text">
                            <span>部分案例</span>
                            <p>多年的发展积累沉淀，已服务200+客户，随商为您提供最优质的产品和高质量的服务</p>
                        </div>
                        <el-carousel indicator-position="outside" class="case-zmd" :interval="5000">
                            <el-carousel-item v-for="item in 3" :key="item">
                                <div class="case-zmd-1">
                                    <div class="zmd-img"><img src="../image/case-img.png" alt=""></div>
                                    <div class="zmd-text">
                                        <div class="zmd-text-1">
                                            <img src="../image/lzlj.png" alt="">
                                            <span>泸州老窖股份有限公司</span>
                                        </div>
                                        <div class="zmd-text-2">400多年酿酒历史的国有控股上市公司</div>
                                        <div class="zmd-text-3">
                                            客户介绍：公司拥有我国建造最早(始建于公元1573年)、连续使用时间最长、保护最完整的老窖池群，1996年经国务院批准为全国重点文物保护单位，被誉为"中国第一窖"，以其独一无二的社会、经济、历史、文化价值成为世界酿酒史上的奇迹。
                                        </div>
                                        <div class="zmd-text-4">
                                            <div class="zmd-text-4-1">电商模式:</div>
                                            <div class="zmd-text-4-2">
                                                <img src="../image/zmd-img1.png" alt="">
                                                <span>PC端</span>
                                            </div>
                                            <div class="zmd-text-4-3">
                                                <img src="../image/zmd-img2.png" alt="">
                                                <span>WAP端</span>
                                            </div>

                                            <div class="zmd-text-4-4">
                                                <img src="../image/zmd-img3.png" alt="">
                                                <span>微信端</span>
                                            </div>

                                            <div class="zmd-text-4-5">
                                                <img src="../image/zmd-img4.png" alt="">
                                                <span>APP</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="cases">
                        <div class="cases1" data-aos="fade-up">
                            更多推荐案例
                        </div>
                        <div class="cases2" data-aos="fade-up">
                            <div class="cases2-1">
                                <img src="../image/cases-1.png" alt="">
                                <div class="cases2-1-1">
                                    <span class="cases-name">成都利群通讯有限责任公司</span>
                                    <div class="cases-name-2">
                                        <div class="cases-name-2-1">电商模式:</div>
                                        <div class="cases-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                        <div class="cases-name-2-3">
                                            <img src="../image/zmd-img5.png" alt="">
                                            <span>小程序</span>
                                        </div>

                                        <div class="cases-name-2-4">
                                            <img src="../image/zmd-img4.png" alt="">
                                            <span>APP</span>
                                        </div>
                                    </div>
                                    <p>利群——是一个针对性的数码产品售卖平台。荟萃了最新最热最酷最有趣的数码产品；后台商品管理、报表、数据分析、库存管理、店铺业绩、优惠券、额度设置、订单核销等…</p>
                                </div>
                            </div>
                            <div class="cases2-2">
                                <img src="../image/cases-2.png" alt="">
                                <div class="cases2-2-1">
                                    <span class="cases2-name">四川省绵阳西南自动化研究所</span>
                                    <div class="cases2-name-2">
                                        <div class="cases2-name-2-1">电商模式:</div>
                                        <div class="cases2-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                    </div>
                                    <p>智慧任务调度平台--支持军工产业各部门任务的智慧调度,该平台实现了军工IOT平台与各类硬件库的对接协议，包含了任务管理、指令下发、4G模块数据管理、硬件心跳包检测等功能
                                    </p>
                                </div>
                            </div>
                            <div class="cases2-3">
                                <img src="../image/cases-3.png" alt="">
                                <div class="cases2-3-1">
                                    <span class="cases3-name">成都珺智升学教育</span>
                                    <div class="cases3-name-2">
                                        <div class="cases3-name-2-1">电商模式:</div>
                                        <div class="cases3-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                        <div class="cases3-name-2-3">
                                            <img src="../image/zmd-img3.png" alt="">
                                            <span>微信端</span>
                                        </div>

                                        <div class="cases3-name-2-4">
                                            <img src="../image/zmd-img4.png" alt="">
                                            <span>APP</span>
                                        </div>
                                    </div>
                                    <p>一款为小升初、初升高提高升学率，更好跟进学生、老师、家长三端联动定制的软件。为提高升学质量，学员管理方便我们才用软件进行有效管理辅助升学质量…</p>
                                </div>
                            </div>
                            <div class="cases2-4">
                                <img src="../image/cases-4.png" alt="">
                                <div class="cases2-4-1">
                                    <span class="cases4-name">多点多新零售SAAS平台</span>
                                    <div class="cases4-name-2">
                                        <div class="cases4-name-2-1">电商模式:</div>
                                        <div class="cases4-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                        <div class="cases4-name-2-3">
                                            <img src="../image/zmd-img3.png" alt="">
                                            <span>微信端</span>
                                        </div>

                                        <div class="cases4-name-2-4">
                                            <img src="../image/zmd-img4.png" alt="">
                                            <span>APP</span>
                                        </div>
                                    </div>
                                    <p>一站式智收银系统，适用于生鲜果蔬零售行业，POSS收银、订单中心、会员管理、交接班、公告、商家收银、我的、数据面板、会员管理、商品管理、订单管理、库存管理…</p>
                                </div>
                            </div>
                            <div class="cases2-5">
                                <img src="../image/cases-5.png" alt="">
                                <div class="cases2-5-1">
                                    <span class="cases5-name">企业设备监控平台</span>
                                    <div class="cases5-name-2">
                                        <div class="cases5-name-2-1">电商模式:</div>
                                        <div class="cases5-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                        <div class="cases5-name-2-3">
                                            <img src="../image/zmd-img3.png" alt="">
                                            <span>微信端</span>
                                        </div>

                                        <div class="cases5-name-2-4">
                                            <img src="../image/zmd-img4.png" alt="">
                                            <span>APP</span>
                                        </div>
                                    </div>
                                    <p>监控系统——持主机各种指标监测——CPU使用率，CPU温度，内存使用率，磁盘容量，磁盘IO，硬盘SMART健康状态，系统负载，连接数量，网卡流量，硬件系统信息等...
                                    </p>
                                </div>
                            </div>
                            <div class="cases2-6">
                                <img src="../image/cases-6.png" alt="">
                                <div class="cases2-6-1">
                                    <span class="cases6-name">吉林牛男奶茶店连锁管理</span>
                                    <div class="cases6-name-2">
                                        <div class="cases6-name-2-1">电商模式:</div>
                                        <div class="cases6-name-2-2">
                                            <img src="../image/zmd-img1.png" alt="">
                                            <span>PC端</span>
                                        </div>
                                        <div class="cases6-name-2-3">
                                            <img src="../image/zmd-img3.png" alt="">
                                            <span>微信端</span>
                                        </div>

                                        <div class="cases6-name-2-4">
                                            <img src="../image/zmd-img4.png" alt="">
                                            <span>APP</span>
                                        </div>
                                    </div>
                                    <p>为门店提供高效全渠道收款，实现扫码秒收款，并记录每笔销售信息。降低员工工作强度，提高工作效率，储值卡管理，帮门和企业迅速回笼资金；帮助制定会员精准营销策略等…</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="定制CRM" namte="second">
                <div class="first-2">
                    暂无内容，敬请期待
                </div>
            </el-tab-pane>
            <el-tab-pane label="其他项目" name="third">
                <div class="first-3">
                    暂无内容，敬请期待
                </div>
            </el-tab-pane>
        </el-tabs>
        <BUTTOM></BUTTOM>
    </div>
</template>

<script>
import { api_category } from "@/APi/api";
import "aos/dist/aos.css";
import AOS from "aos/dist/aos.js";
export default {
    data() {
        return {
            activeName: 'first',
            navList: [],
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleScroll() {
            const nav = document.querySelector('.tac'); // 导航栏元素
            const distanceFromTop = nav.offsetTop; // 导航栏距离顶部的距离

            if (window.pageYOffset > distanceFromTop) { // 当滚动距离超过导航栏距离顶部的距离时
                nav.classList.add('fixed'); // 添加固定样式类
            } else {
                nav.classList.remove('fixed'); // 移除固定样式类
            }
        },
        // 获取栏目列表
        getCategory() {
            api_category().then((res) => {
                this.navList = res.data;
                // console.log(this.navList)
            });
        }
    },
    created() {
        this.getCategory();
    },
    mounted() {
        if (!sessionStorage.getItem('isRefreshed')) {
            sessionStorage.setItem('isRefreshed', true);
            window.location.reload();
        } else {
            sessionStorage.removeItem('isRefreshed');
        }
        window.addEventListener('scroll', this.handleScroll);
        AOS.init({
            offset: 200,
            duration: 600,
            easing: "ease-in-sine",
            delay: 400,
        });
    }
}
</script>

<style lang="scss" scoped>
// element-tabs
::v-deep .el-tabs__nav-wrap::after {
    display: none;
}

::v-deep .el-tabs__active-bar {
    display: none;
}

// 
// element-ui走马灯
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

// .el-carousel__item:nth-child(2n) {
//     background-color: #99a9bf;
// }

::v-deep .el-carousel__arrow--left {
    left: -90px;
}

::v-deep .el-carousel__arrow--right,
.el-notification.right {
    right: -90px;
}

::v-deep .el-carousel__container {
    width: 62.5rem !important;
    margin: 0 auto;
    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
    border-radius: 0.69rem;
}

// 结束element-ui走马灯
* {
    padding: 0;
    margin: 0;
}

// 导航菜单
::v-deep .el-row {
    width: 13rem;
}

::v-deep .el-submenu {
    width: 13rem;
}

::v-deep .el-col-12 {
    width: 100%;
}

::v-deep .el-menu {
    background-color: transparent;
    display: flex;
    flex-direction: column;
}

::v-deep .el-submenu .el-menu-item {
    color: white;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

::v-deep .el-submenu__title {
    color: white;
    background-color: transparent !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

::v-deep .el-icon-arrow-down:before {
    color: white;
}

::v-deep .el-submenu .el-menu-item {
    background-color: transparent !important;
}

::v-deep .el-menu {
    background-color: transparent !important;
}
::v-deep .el-tabs__nav{
    width: 30rem;
}
::v-deep .el-tabs__item.is-active {
        width: 10rem;
        text-align: center;
        padding: 0;
        background-color: #014f93;
        color: white;
    }
    ::v-deep .el-tabs__item {
        width: 33.3333%;
        text-align: center;
        height: 40px;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        position: relative;
    }
.tac {
    z-index: 3;
    position: absolute;
    right: 0;
    top: 0;
    background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
}

::v-deep .el-menu-item-group>ul {
    height: 44rem;
}

.tac.fixed {
    position: fixed;
    right: 0;
}

.linkclass {
    text-decoration: none;
    color: white;
}

// 
.top {
    width: 100%;
    height: 15.13rem;
    background-image: url(../image/banner-2.png);
    background-size: 100% 100%;
    margin-bottom: 4.2rem;

    .loGo {
        width: 8.13rem;
        height: 2.51rem;
        margin-left: 5.81rem;
    }

    .logo-1 {
        width: 1.63rem;
        height: 1.63rem;
        margin-right: 5.81rem;
    }

    // .introduce {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     position: absolute;
    //     left: 50%;
    //     transform: translateX(-50%);
    //     top: 7rem;

    //     .p1 {
    //         font-size: 2.25rem;
    //         color: white;
    //     }

    //     .p2 {
    //         font-size: 1.13rem;
    //         color: white;
    //     }
    // }
    .links {
        width: 15rem;
        height: 4.38rem;
        font-size: 1.13rem;
        color: #FFFFFF;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        padding-top: 2rem;
        margin: 0 auto;

        .links-2-1 {
            color: white;
            text-decoration: none;
        }

        .links-1 {
            background-color: white;
            color: #014F93;
        }

        span {
            width: 7.13rem;
            height: 4.38rem;
            text-align: center;
            line-height: 4.38rem;
            cursor: pointer;
            cursor: zoom-in;
            transition: font-size 0.2s ease-in-out;
        }

        span:hover {
            font-size: 1.2em;
            cursor: pointer;
        }
    }
}

.tabs-1 {
    width: 75.25rem;
    margin: 0 auto;
    margin-top: 1rem;

    .first-1 {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 3rem;

        .first-text {
            width: 100%;
            height: 4.5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1.8rem;

            span {
                font-size: 1.88rem;
            }

            span:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            p:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            p {
                color: #999999;
                font-size: 0.88rem;

            }
        }

        .first-image {
            width: 100%;
            height: 24.25rem;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            margin-bottom: 3.8rem;

            .first-image-1 {
                width: 16rem;
                height: 100%;
                background-image: url(../image/green.png);
                background-size: 100% 100%;
                color: white;

                span {
                    font-size: 1.25rem;
                    margin-left: 1.69rem;
                    line-height: 4rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                p {
                    font-size: 1rem;
                    margin-left: 1.69rem;
                    margin-bottom: 0.75rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                span:hover {
                    color: #014F93;
                }

                p:hover {
                    color: #014F93;
                }
            }

            .first-image-2 {
                width: 16rem;
                height: 100%;
                background-image: url(../image/blue.png);
                background-size: 100% 100%;
                color: white;

                span {
                    font-size: 1.25rem;
                    margin-left: 1.69rem;
                    line-height: 4rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                p {
                    font-size: 1rem;
                    margin-left: 1.69rem;
                    margin-bottom: 0.75rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                span:hover {
                    color: #014F93;
                }

                p:hover {
                    color: #014F93;
                }
            }

            .first-image-3 {
                width: 16rem;
                height: 100%;
                background-image: url(../image/orange.png);
                background-size: 100% 100%;
                color: white;

                span {
                    font-size: 1.25rem;
                    margin-left: 1.69rem;
                    line-height: 4rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                p {
                    font-size: 1rem;
                    margin-left: 1.69rem;
                    margin-bottom: 0.75rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                span:hover {
                    color: #014F93;
                }

                p:hover {
                    color: #014F93;
                }
            }

            .first-image-4 {
                width: 16rem;
                height: 100%;
                background-image: url(../image/purple.png);
                background-size: 100% 100%;
                color: white;

                span {
                    font-size: 1.25rem;
                    margin-left: 1.69rem;
                    line-height: 4rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                p {
                    font-size: 1rem;
                    margin-left: 1.69rem;
                    margin-bottom: 0.75rem;
                    transition: color 0.3s ease-in-out;
                    /* 添加过渡效果 */
                    cursor: pointer;
                }

                span:hover {
                    color: #014F93;
                }

                p:hover {
                    color: #014F93;
                }
            }
        }
    }

    .first-text-2 {
        width: 100%;
        height: 24rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4rem;

        .f-text1 {
            font-size: 1.88rem;
        }

        .f-text1:hover {
            transition: all .6s linear;
            color: rgb(1, 79, 147);
            cursor: pointer;
        }

        .f-text2 {
            width: 100%;
            height: 17.5rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            img {
                width: 6.81rem;
                height: 6.81rem;
                margin-bottom: 1.63rem;
                cursor: pointer;
            }

            .f-text2-1 {
                width: 15.6rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                    font-size: 1.38rem;
                    margin-bottom: 0.75rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    font-size: 0.88rem;
                    color: #666666;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text2-2 {
                width: 15.6rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                    font-size: 1.38rem;
                    margin-bottom: 0.75rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    font-size: 0.88rem;
                    color: #666666;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text2-3 {
                width: 15.6rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                    font-size: 1.38rem;
                    margin-bottom: 0.75rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    font-size: 0.88rem;
                    color: #666666;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text2-4 {
                width: 15.6rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                    font-size: 1.38rem;
                    margin-bottom: 0.75rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    font-size: 0.88rem;
                    color: #666666;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }
        }
    }

    .first-text-3 {
        width: 100%;
        height: 29rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 5rem;

        .f-text-3-1 {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 5.56rem;

            span {
                font-size: 1.88rem;
                margin-bottom: 0.75rem;
            }

            span:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            p {
                color: #999999;
                font-size: 0.88rem;
            }

            p:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }
        }

        .f-text-3-2 {
            width: 100%;
            height: 20.81rem;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            color: white;

            img {
                width: 4.06rem;
                height: 4.06rem;
                margin-top: 2.88rem;
                margin-bottom: 3rem;
            }

            .f-text3-2-1 {
                width: 16rem;
                height: 100%;
                background-color: #7594FD;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 0.69rem;

                span {
                    font-size: 1.25rem;
                    margin-bottom: 0.87rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    width: 12.88rem;
                    font-size: 0.88rem;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text3-3-1 {
                width: 16rem;
                height: 100%;
                background-color: #7594FD;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 0.69rem;

                span {
                    font-size: 1.25rem;
                    margin-bottom: 0.87rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    width: 12.88rem;
                    font-size: 0.88rem;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text3-4-1 {
                width: 16rem;
                height: 100%;
                background-color: #7594FD;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 0.69rem;

                span {
                    font-size: 1.25rem;
                    margin-bottom: 0.87rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    width: 12.88rem;
                    font-size: 0.88rem;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text3-5-1 {
                width: 16rem;
                height: 100%;
                background-color: #7594FD;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 0.69rem;

                span {
                    font-size: 1.25rem;
                    margin-bottom: 0.87rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    width: 12.88rem;
                    font-size: 0.88rem;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }
        }
    }

    .case {
        width: 100%;
        height: 27rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 4rem;

        .case-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 2rem;

            span {
                font-size: 1.88rem;
                margin-bottom: 0.75rem;
            }

            span:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            p {
                font-size: 0.88rem;
                color: #999999;
            }

            p:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }
        }

        .case-zmd {
            width: 100%;
            height: 20.7rem;

            .case-zmd-1 {
                width: 62.5rem;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .zmd-img {
                    width: 25.25rem;
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .zmd-text {
                    width: 37.25rem;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    margin-left: 2.06rem;

                    .zmd-text-1 {
                        height: 2.69rem;
                        display: flex;
                        align-items: center;

                        img {
                            width: 7.5rem;
                            height: 2.69rem;
                        }

                        span {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            margin-left: 1.75rem;
                        }

                        span:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }
                    }

                    .zmd-text-2 {
                        font-size: 0.88rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .zmd-text-2:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    .zmd-text-3 {
                        width: 32.75rem;
                        font-size: 0.88rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 1.75rem;
                    }

                    .zmd-text-3:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    .zmd-text-4 {
                        width: 28rem;
                        display: flex;
                        justify-content: space-between;
                        flex-direction: row;
                        color: #666666;
                        font-size: 0.88rem;

                        .zmd-text-4-2 {
                            display: flex;
                            align-items: center;

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .zmd-text-4-3 {
                            display: flex;
                            align-items: center;

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .zmd-text-4-4 {
                            display: flex;
                            align-items: center;

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .zmd-text-4-5 {
                            display: flex;
                            align-items: center;

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }
                }
            }
        }
    }

    .cases {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 7rem;

        .cases1 {
            font-size: 1.88rem;
            margin-bottom: 4rem;
        }

        .cases1:hover {
            transition: all .6s linear;
            color: rgb(1, 79, 147);
            cursor: pointer;
        }

        .cases2 {
            width: 100%;
            min-height: 75rem;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-evenly;
            flex-wrap: wrap;

            .cases2-1 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-1-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    span:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                }
            }

            .cases2-2 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-2-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases2-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases2-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases2-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases2-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases2-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases2-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                }
            }

            .cases2-3 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-3-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases3-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases3-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases3-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases3-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases3-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases3-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }
                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                }
            }

            .cases2-4 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-4-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases4-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases4-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases4-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases4-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases4-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases4-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }
                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                }
            }

            .cases2-5 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-5-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases5-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases5-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases5-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases5-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases5-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases5-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }
                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                }
            }

            .cases2-6 {
                width: 28.25rem;
                height: 22.81rem;
                display: flex;
                flex-direction: column;
                box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                border-radius: 0.75rem;

                .cases2-6-1 {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-evenly;
                    margin-left: 1.38rem;

                    .cases6-name {
                        font-size: 1rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }

                    .cases6-name-2 {
                        display: flex;
                        flex-direction: row;

                        .cases6-name-2-1 {
                            font-size: 0.88rem;
                        }

                        .cases6-name-2-2 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases6-name-2-3 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }

                        .cases6-name-2-4 {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;
                            margin-left: 1rem;

                            img {
                                width: 1rem;
                                height: 1rem;
                            }

                            span {
                                margin-left: 0.63rem;
                            }
                        }
                    }

                    p {
                        width: 25.25rem;
                        font-size: 0.88rem;
                        color: #999999;
                    }
                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                }
            }
        }
    }

    // tabs2
    .first-2 {
        width: 100%;
        height: 30rem;
    }

    // tabs3
    .first-3 {
        width: 100%;
        height: 30rem;
    }
}

// 移动端
@media screen and (max-width: 900px) {

    // 移动
    // element-tabs
    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    ::v-deep .el-tabs__nav {
        width: 100%;
        display: flex;
        white-space: nowrap;
        position: relative;
        transition: transform .3s;
        float: left;
        z-index: 2;
        justify-content: space-around;
        flex-direction: row;
        align-items: center;
        background-color: rgb(240, 242, 245);
    }

    ::v-deep .el-tabs__item.is-active {
        color: white;
        background-color: #014f93;
    }

    ::v-deep .el-tabs__item {
        width: 33%;
        text-align: center;
        height: 40px;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        position: relative;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    ::v-deep .el-tabs__active-bar {
        display: none;
    }

    ::v-deep .el-tabs__nav-scroll {
        overflow: hidden;
        width: 100%;
        margin: auto;
        height: 3rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    // 
    // element-ui走马灯
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    // .el-carousel__item:nth-child(2n) {
    //     background-color: #99a9bf;
    // }

    ::v-deep .el-carousel__arrow--left {
        left: -90px;
    }

    ::v-deep .el-carousel__arrow--right,
    .el-notification.right {
        right: -90px;
    }

    ::v-deep .el-carousel__container {
        width: 100% !important;
        margin: 0 auto;
        box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
        border-radius: 0.69rem;
        height: 40rem;
    }

    ::v-deep .el-carousel__item.is-animating {
        display: flex;
        flex-direction: column;
    }

    // 结束element-ui走马灯
    * {
        padding: 0;
        margin: 0;
    }

    // 导航菜单
    ::v-deep .el-row {
        width: 13rem;
    }

    ::v-deep .el-submenu {
        width: 100%;
    }

    ::v-deep .el-col-12 {
        width: 100%;
    }

    ::v-deep .el-menu {
        background-color: transparent;
        display: flex;
        flex-direction: column;
    }

    ::v-deep .el-submenu .el-menu-item {
        color: white;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    ::v-deep .el-submenu__title {
        color: white;
        background-color: transparent !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 8.5rem;
    }

    ::v-deep .el-icon-arrow-down:before {
        color: white;
    }

    ::v-deep .el-submenu .el-menu-item {
        background-color: transparent !important;
    }

    ::v-deep .el-menu {
        background-color: transparent !important;
    }

    .tac {
        width: 35%;
        z-index: 3;
        position: absolute;
        right: 0;
        top: 0;
        background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
    }

    ::v-deep .el-menu-item-group>ul {
        height: 50rem;
    }

    .tac.fixed {
        position: fixed;
        right: 0;
    }

    .linkclass {
        text-decoration: none;
        color: white;
    }

    // 
    .top {
        width: 100%;
        height: 15.13rem;
        background-image: url(../image/banner-2.png);
        background-size: 100% 100%;
        margin-bottom: 1rem;

        .loGo {
            width: 8.13rem;
            height: 2.51rem;
            margin-left: 0rem;
            margin-top: 0.5rem;
        }

        .logo-1 {
            width: 1.63rem;
            height: 1.63rem;
            margin-right: 5.81rem;
        }

        // .introduce {
        //     display: flex;
        //     flex-direction: column;
        //     align-items: center;
        //     position: absolute;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     top: 7rem;

        //     .p1 {
        //         display: none;
        //         font-size: 2.25rem;
        //         color: white;
        //     }

        //     .p1none {
        //         display: block !important;
        //         font-size: 2rem;
        //         color: white;
        //     }

        //     .p2 {
        //         display: none;
        //         font-size: 1.13rem;
        //         color: white;
        //     }

        //     .p2none {
        //         display: block !important;
        //         font-size: 1.13rem;
        //         color: white;
        //     }
        // }
        .links {
            width: 15rem;
            height: 4.38rem;
            font-size: 1.13rem;
            color: #FFFFFF;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
            padding-top: 2rem;
            margin: 0 auto;

            .links-2-1 {
                color: white;
                text-decoration: none;
            }

            .links-1 {
                background-color: white;
                color: #014F93;
            }

            span {
                width: 7.13rem;
                height: 4.38rem;
                text-align: center;
                line-height: 4.38rem;
                cursor: pointer;
                cursor: zoom-in;
                transition: font-size 0.2s ease-in-out;
            }

            span:hover {
                font-size: 1.2em;
                cursor: pointer;
            }
        }
    }

    .tabs-1 {
        width: 100%;
        margin: 0 auto;
        margin-top: 1rem;

        .first-1 {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 3rem;

            .first-text {
                width: 100%;
                height: 7.5rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 1.8rem;

                span {
                    font-size: 1.2rem;
                    width: 80%;
                    font-weight: 600;
                    text-align: center;
                }

                p {
                    color: #999999;
                    font-size: 0.88rem;
                    width: 90%;
                    text-align: center;

                }
            }

            .first-image {
                width: 100%;
                height: 35rem;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                margin-bottom: 3.8rem;
                flex-wrap: wrap;

                .first-image-1 {
                    width: 48%;
                    height: 17rem;
                    background-image: url(../image/green.png);
                    background-size: 100% 100%;
                    color: white;

                    span {
                        font-size: 1rem;
                        font-weight: 600;
                        margin-left: 1.69rem;
                        line-height: 4rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    p {
                        font-size: 0.8rem;
                        margin-left: 1.69rem;
                        margin-bottom: 0.75rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    span:hover {
                        color: #014F93;
                    }

                    p:hover {
                        color: #014F93;
                    }
                }

                .first-image-2 {
                    width: 48%;
                    height: 17rem;
                    background-image: url(../image/blue.png);
                    background-size: 100% 100%;
                    color: white;

                    span {
                        font-size: 1rem;
                        font-weight: 600;
                        margin-left: 1.69rem;
                        line-height: 4rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    p {
                        font-size: 0.8rem;
                        margin-left: 1.69rem;
                        margin-bottom: 0.75rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    span:hover {
                        color: #014F93;
                    }

                    p:hover {
                        color: #014F93;
                    }
                }

                .first-image-3 {
                    width: 48%;
                    height: 17rem;
                    background-image: url(../image/orange.png);
                    background-size: 100% 100%;
                    color: white;

                    span {
                        font-size: 1rem;
                        font-weight: 600;
                        margin-left: 1.69rem;
                        line-height: 4rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    p {
                        font-size: 0.8rem;
                        margin-left: 1.69rem;
                        margin-bottom: 0.75rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    span:hover {
                        color: #014F93;
                    }

                    p:hover {
                        color: #014F93;
                    }
                }

                .first-image-4 {
                    width: 48%;
                    height: 17rem;
                    background-image: url(../image/purple.png);
                    background-size: 100% 100%;
                    color: white;

                    span {
                        font-size: 1rem;
                        font-weight: 600;
                        margin-left: 1.69rem;
                        line-height: 4rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    p {
                        font-size: 0.8rem;
                        margin-left: 1.69rem;
                        margin-bottom: 0.75rem;
                        transition: color 0.3s ease-in-out;
                        /* 添加过渡效果 */
                        cursor: pointer;
                    }

                    span:hover {
                        color: #014F93;
                    }

                    p:hover {
                        color: #014F93;
                    }
                }
            }
        }

        .first-text-2 {
            width: 100%;
            height: 40rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4rem;

            .f-text1 {
                font-size: 1.2rem;
                font-weight: 600;
            }

            .f-text1:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            .f-text2 {
                width: 100%;
                height: 36.5rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;

                img {
                    width: 4.81rem;
                    height: 4.81rem;
                    margin-bottom: 1.63rem;
                }

                .f-text2-1 {
                    width: 48%;
                    height: 19rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    span {
                        font-size: 1.2rem;
                        font-weight: 600;
                        margin-bottom: 0.75rem;

                        span:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }

                        p {
                            font-size: 0.88rem;
                            color: #666666;
                        }

                        p:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }
                    }


                }

                .f-text2-2 {
                    width: 48%;
                    height: 19rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    span {
                        font-size: 1.2rem;
                        font-weight: 600;
                        margin-bottom: 0.75rem;
                    }

                    p {
                        font-size: 0.88rem;
                        color: #666666;
                    }
                }

                .f-text2-3 {
                    width: 48%;
                    height: 19rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    span {
                        font-size: 1.2rem;
                        font-weight: 600;
                        margin-bottom: 0.75rem;
                    }

                    p {
                        font-size: 0.88rem;
                        color: #666666;
                    }
                }

                .f-text2-4 {
                    width: 48%;
                    height: 19rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    span {
                        font-size: 1.2rem;
                        font-weight: 600;
                        margin-bottom: 0.75rem;
                    }

                    p {
                        font-size: 0.88rem;
                        color: #666666;
                    }
                }
            }
        }

        .first-text-3 {
            width: 100%;
            height: 42rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 5rem;

            .f-text-3-1 {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 2.5rem;

                span {
                    font-size: 1.2rem;
                    font-weight: 600;
                    margin-bottom: 0.75rem;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    color: #999999;
                    font-size: 0.88rem;
                    width: 92%;
                    text-align: center;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .f-text-3-2 {
                width: 100%;
                height: 31rem;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: space-between;
                color: white;
                flex-wrap: wrap;

                img {
                    width: 3.06rem;
                    height: 3.06rem;
                    margin-top: 1rem;
                    margin-bottom: 1rem;
                }

                .f-text3-2-1 {
                    width: 48%;
                    height: 15rem;
                    background-color: #7594FD;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-radius: 0.69rem;

                    span {
                        font-size: 1.2rem;
                        margin-bottom: 0.87rem;
                    }

                    span:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    p {
                        width: 9.88rem;
                        font-size: 0.88rem;
                        text-align: center;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                }

                .f-text3-3-1 {
                    width: 48%;
                    height: 15rem;
                    background-color: #7594FD;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-radius: 0.69rem;

                    span {
                        font-size: 1.2rem;
                        margin-bottom: 0.87rem;
                    }

                    span:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    p {
                        width: 9.88rem;
                        font-size: 0.88rem;
                        text-align: center;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                }

                .f-text3-4-1 {
                    width: 48%;
                    height: 15rem;
                    background-color: #7594FD;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-radius: 0.69rem;

                    span {
                        font-size: 1.2rem;
                        margin-bottom: 0.87rem;
                    }

                    span:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    p {
                        width: 9.88rem;
                        font-size: 0.88rem;
                        text-align: center;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                }

                .f-text3-5-1 {
                    width: 48%;
                    height: 15rem;
                    background-color: #7594FD;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-radius: 0.69rem;

                    span {
                        font-size: 1.2rem;
                        margin-bottom: 0.87rem;
                    }

                    span:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }

                    p {
                        width: 9.88rem;
                        font-size: 0.88rem;
                        text-align: center;
                    }

                    p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                }
            }
        }

        .case {
            width: 100%;
            height: 50rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 4rem;

            .case-text {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 2rem;

                span {
                    font-size: 1.2rem;
                    margin-bottom: 0.75rem;
                    font-weight: 600;
                }

                span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }

                p {
                    font-size: 0.88rem;
                    color: #999999;
                    width: 90%;
                    text-align: center;
                }

                p:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
            }

            .case-zmd {
                width: 100%;
                height: 43rem;

                .case-zmd-1 {
                    width: 62.5rem;
                    height: 100%;
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;

                    .zmd-img {
                        width: 25.25rem;
                        height: 100%;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .zmd-text {
                        width: 37.25rem;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        margin-left: 1rem;

                        .zmd-text-1 {
                            height: 2.69rem;
                            display: flex;
                            align-items: center;
                            margin-left: 2%;

                            img {
                                width: 7.5rem;
                                height: 2.69rem;
                            }

                            span {
                                font-size: 1.2rem;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                margin-left: 1.75rem;
                            }

                            span:hover {
                                transition: all .6s linear;
                                color: rgb(1, 79, 147);
                                cursor: pointer;
                            }
                        }

                        .zmd-text-2 {
                            font-size: 0.88rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            margin-left: 10%;
                        }

                        .zmd-text-2:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }

                        .zmd-text-3 {
                            width: 62%;
                            font-size: 0.88rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #666666;
                            line-height: 1.75rem;
                        }

                        .zmd-text-3:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }

                        .zmd-text-4 {
                            width: 21rem;
                            display: flex;
                            justify-content: space-between;
                            flex-direction: row;
                            color: #666666;
                            font-size: 0.88rem;

                            .zmd-text-4-2 {
                                display: flex;
                                align-items: center;

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .zmd-text-4-3 {
                                display: flex;
                                align-items: center;

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .zmd-text-4-4 {
                                display: flex;
                                align-items: center;

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .zmd-text-4-5 {
                                display: flex;
                                align-items: center;

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            img {
                                width: 1rem;
                                height: 1rem;
                            }
                        }
                    }
                }
            }
        }

        .cases {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 7rem;

            .cases1 {
                font-size: 1.88rem;
                margin-bottom: 4rem;
            }

            .cases1:hover {
                transition: all .6s linear;
                color: rgb(1, 79, 147);
                cursor: pointer;
            }

            .cases2 {
                width: 100%;
                min-height: 75rem;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: space-evenly;
                flex-wrap: wrap;

                .cases2-1 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-1-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }

                        p:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }

                        span:hover {
                            transition: all .6s linear;
                            color: rgb(1, 79, 147);
                            cursor: pointer;
                        }
                    }
                }

                .cases2-2 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-2-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases2-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases2-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases2-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases2-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases2-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases2-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }
                        p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                    }
                }

                .cases2-3 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-3-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases3-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases3-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases3-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases3-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases3-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases3-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }
                        p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                    }
                }

                .cases2-4 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-4-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases4-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases4-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases4-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases4-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases4-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases4-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }
                        p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                    }
                }

                .cases2-5 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-5-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases5-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases5-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases5-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases5-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases5-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases5-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }
                        p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                    }
                }

                .cases2-6 {
                    width: 95%;
                    height: 22.81rem;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0rem 0.63rem 1.19rem 0rem rgba(0, 0, 0, 0.09);
                    border-radius: 0.75rem;
                    margin-bottom: 2rem;

                    .cases2-6-1 {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-evenly;
                        margin-left: 1.38rem;

                        .cases6-name {
                            font-size: 1rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                        }

                        .cases6-name-2 {
                            display: flex;
                            flex-direction: row;

                            .cases6-name-2-1 {
                                font-size: 0.88rem;
                            }

                            .cases6-name-2-2 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases6-name-2-3 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }

                            .cases6-name-2-4 {
                                display: flex;
                                align-items: center;
                                flex-direction: row;
                                color: #666666;
                                font-size: 0.88rem;
                                margin-left: 1rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                }

                                span {
                                    margin-left: 0.63rem;
                                }
                            }
                        }

                        p {
                            width: 100%;
                            font-size: 0.88rem;
                            color: #999999;
                        }
                        p:hover {
                        transition: all .6s linear;
                        color: rgb(1, 79, 147);
                        cursor: pointer;
                    }
                    span:hover {
                    transition: all .6s linear;
                    color: rgb(1, 79, 147);
                    cursor: pointer;
                }
                    }
                }
            }
        }

        // tabs2
        .first-2 {
            width: 100%;
            height: 30rem;
        }

        // tabs3
        .first-3 {
            width: 100%;
            height: 30rem;
        }
    }
}</style>